<template>
  <div>
    <transition name="slide-fade">
      <div class='mode_body' v-if='ismodeltab'>
        <div
          style="background-color: #0097a8;padding: 0.5rem .9rem;color: #fff;font-size: .8rem;display: flex;justify-content: space-between;">
          <div style="font-size: 18px;">{{tabfrom.title}}</div>
          <a-icon type="close" style='font-size: 1.2rem;' @click='$emit("child",1)' />
        </div>
        <div class='mytitle'>
          <a-icon type="left" class='my_left' @click='unmodeltab = true'/>
          <div style="font-size: 18px;">{{tabfrom.taname}}</div>
        </div>
        <div id="my_text">
          <div v-for='(v,i) in tabfrom.list' @click='open(i)'>{{v}}</div>
        </div>
      </div>
    </transition>
    <transition name="slide-fades">
    <div class='mode_body_top' v-if='unmodeltab'>
      <div
        style="background-color: #0097a8;padding: 0.5rem .9rem;color: #fff;font-size: .8rem;display: flex;justify-content: space-between;">
        <div style="font-size: 18px;">證券服務</div>
        <a-icon type="close" style='font-size: 1.2rem;' @click='unmodeltab =false' />
      </div>
      <div class='mytitle'>
        <div style="font-size: 18px;">證券服務</div>
      </div>
      <div id="my_text1">
        <div v-for='(v,i) in list' @click='openfn(v.url)'>{{islang=="eng"?v.name_en:v.name}}
        <!-- <a-icon type="right" class='my_left1' /> -->
        </div>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: ['tabfrom','ismodeltab'],
    data() {
      return {
        islang : window.localStorage.guanwanglang,
        unmodeltab:false,
        show: false,
        list:
        // ['香港股票','新股認購','環球股票','債券服務','基金服務','滬深港通','股票轉倉'],//,'服務收費'
        [
        {name:'開立帳戶',url:'/apply_in_person_individual',name_en:'Account Opening'},
        // {name:'數據服務',url:'/market_data',name_en:'Market Data Service'},
        // {name:'資金存取',url:'/deposit&withdrawal',name_en:'Deposit & Withdrawal'},//
        // {name:'表格下載',url:'/download_form',name_en:'Download Forms'},
        // {name:'常見問題',url:'/FAQs',name_en:'FAQs'},//
        // {name:this.$lang.gzjq,url:'/market_holiday',name_en:this.$lang.gzjq},
        // {name:this.$lang.jytg,url:'/trading_announcement',name_en:this.$lang.jytg},
        ],
        // urllist:['/hksecurities_introduction','/ipo_subscriptions','/ussecurities_introduction','/bonds_introduction','/fund_introduction','/stockconnect_introduction','/securities_transfer'],//,'/services_fee'
      }
    },
    methods: {
      open(e) {
        if(this.tabfrom.urllist[e].split('http').length>1){
          window.open(this.tabfrom.urllist[e] + this.islang)
        }else{
          this.$router.push(this.tabfrom.urllist[e])
        }
      },
      openfn(e){
        this.$router.push(e)
      }
    }
  }
</script>

<style scoped>
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter,
  .slide-fade-leave-to

  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */
    {
    transform: translateX(100%);
    transition: all .5s ease;
  }

  .slide-fades-enter-active {
    transition: all .4s ease;
  }

  .slide-fades-leave-active {
    transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fades-enter,
  .slide-fades-leave-to

  /* .slide-fade-leave-active 用于 2.1.8 以下版本 */
    {
    transform: translateX(-100%);
    transition: all .4s ease;
  }

  .mode_body {
    width: 100%;
    z-index: 101;
    background-color: #fff;
    position: fixed;
    height: calc(100vh - 5.35rem);
    /* bottom: 0; */
    top: 5.35rem;
  }
  .mode_body_top{
    width: 100%;
    z-index: 105;
    background-color: #fff;
    position: fixed;
    height: calc(100vh - 5.35rem);
    /* bottom: 0; */
    top: 5.35rem;
  }
  .mode_body_top #my_text1 div{
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin: 5px 10px;
  }
  #my_text1 .my_left1 {
    position: relative;
    top: 5px;
  }
  .mytitle {
    padding: 10px;
    text-align: center;
    position: relative;
    font-size: 16px;
  }

  .mytitle div {
    color: #307c83;
    display: inline-block;
    margin: 0 auto;
    font-weight: 600;
  }

  .mytitle .my_left {
    position: absolute;
    left: 10px;
    top: 13px;
  }

  #my_text,#my_text1 div {
    font-size: 16px;
    margin: 5px 10px;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/modeltab/modeltabs.vue